export default {
	SET_AUTH: (state, data) => {
        state.auth = {
            ...state.auth,
            ...data
        };
    },
}